<template>
  <b-navbar
    toggleable="md"
    type="light"
    variant="light"
  >
    <b-navbar-toggle target="nav_collapse" />

    <b-navbar-brand>
      Habit Tracker
    </b-navbar-brand>

    <b-collapse
      id="nav_collapse"
      is-nav
    >
      <b-navbar-nav>
        <b-nav-item
          v-for="(item, key) in leftIcons"
          :key="key"
        >
          <RouterLink :to="item.route">
            <FontAwesomeIcon
              class="icon-link"
              :icon="item.icon"
            />
          </RouterLink>
        </b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown
          text="Lang"
          right
        >
          <b-dropdown-item>
            EN
          </b-dropdown-item>
          <b-dropdown-item>
            ES
          </b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          :text="`${$auth.check() ? $auth.user().name : 'User'}`"
          right
        >
          <!-- Using button-content slot -->
          <b-dropdown-item v-if="$auth.check()">
            <RouterLink to="/logout">
              Sign Out
            </RouterLink>
          </b-dropdown-item>
          <b-dropdown-item v-else>
            <RouterLink to="/login">
              Sign In
            </RouterLink>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import datetime from '@/helpers/datetime';

export default {
  data() {
    return {
      leftIcons: [
        {
          icon: 'home',
          route: '/',
        },
        // {
        //   icon: 'calendar',
        //   route: '/perf',
        // },
        {
          icon: 'file-contract',
          route: '/trackers',
        },
      ],
      date: datetime.displayDate(),
    };
  },
};
</script>

<style scoped>
.icon-link {
  color: #111;
}
</style>
